<template>
    <button 
        :class="[block, isOpen ? '-open' : '-closed']"
        :aria-expanded="`${isOpen}`"
        :aria-controls="id"
        tabindex="0"
        role="button"
        @click="open"   
    >
        <div
            :id="`${id}-control`"
            :class="`${block}__${headerElement}`"
        >
            <slot name="heading" />
            <slot name="icon">
                <!-- Minus Sign if Closed -->
                <svg
                    :class="`${block}__icon`"
                    width="24"
                    height="24"
                    viewBox="0 0 448 512"
                    v-if="isOpen"
                >
                    <path
                        d="M432 256C432 269.3 421.3 280 408 280H40c-13.25 0-24-10.74-24-23.99C16 242.8 26.75 232 40 232h368C421.3 232 432 242.8 432 256z"
                    >
                    <title>Menu</title>
                    </path>
                </svg>
                <!-- Plus Sign if Open -->
                <svg
                    :class="`${block}__icon`"
                    width="24"
                    height="24"
                    viewBox="0 0 448 512"
                    v-else
                >
                    <path
                        d="M432 256C432 269.3 421.3 280 408 280h-160v160c0 13.25-10.75 24.01-24 24.01S200 453.3 200 
                    440v-160h-160c-13.25 0-24-10.74-24-23.99C16 242.8 26.75 232 40 232h160v-160c0-13.25 10.75-23.99 24-23.99S248 
                    58.75 248 72v160h160C421.3 232 432 242.8 432 256z"
                    />
                </svg>
            </slot>
        </div>
        <transition
            name="accordion__transition"
            @enter="startTransition"
            @after-enter="endTransition"
            @before-leave="startTransition"
            @after-leave="endTransition"
        >
            <div
                v-if="isOpen"
                :id="id"
                ref="content"
                :class="`${block}__${contentElement}`"
                :aria-labelledby="`${id}-control`"
            >
                <slot />
            </div>
        </transition>
    </button>
</template>
<script>
export default {
    props: {
        block: {
            type: String,
            default: "accordion",
        },
        headerElement: {
            type: String,
            default: "header",
        },
        contentElement: {
            type: String,
            default: "content",
        },
        id: {
            type: String,
            default: () => Math.random().toString(36).substr(2),
        },
    },
    data: () => ({ isOpen: false }),
    methods: {
        open() {
            this.isOpen = !this.isOpen;
        },

        /**
         * The following methods and transition hooks are necessary to work
         * around the fact that CSS transitions can't navigate to auto values.
         */
        startTransition(el) {
            el.style.height = el.scrollHeight + "px";
        },
        endTransition(el) {
            el.style.height = "";
        },
    },
};
</script>
